import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import request from './utils/request.js'
import validator from './utils/validator.js'
import util from './utils/util.js'
import redirectTo from './utils/redirectTo.js'
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import storage from 'store'

// 组件
const app = createApp(App);

// 挂载全局
app.config.globalProperties.$request = request;
app.config.globalProperties.$validator = validator;
app.config.globalProperties.$util = util;
app.config.globalProperties.$redirectTo = redirectTo;

app.use(store).use(router).use(Vant).use(storage).use(ElementPlus, { locale }).mount('#app');




// VueAMap.initAMapApiLoader({
//   key: '7139a27fab8c9ab16fdf4defabe7ea39',
//   plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
//   v: '1.4.4',
//   uiVersion: '1.0'
// })
